
import { useState } from 'react';
import Header from './components/Header';
import TabBar from './components/TabBar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LiveAuctions from './components/LiveAuctions';
import FeaturedAuctions from './components/FeaturedAuctions';

export default function Home() {
  const [activeTab, setActiveTab] = useState('home');

  return (
    <div className="min-h-screen bg-black text-white" style={{ fontFamily: 'Cairo, sans-serif' }}>
      <Header />
      
      <main className="pt-16 pb-20">
        {activeTab === 'home' && (
          <>
            <HeroSection />
            <CategoryGrid />
            <LiveAuctions />
            <FeaturedAuctions />
          </>
        )}
        
        {activeTab === 'auctions' && (
          <div className="px-4 py-6">
            <h2 className="text-xl font-bold mb-4">جميع المزادات</h2>
            <LiveAuctions showAll={true} />
          </div>
        )}
        
        {activeTab === 'favorites' && (
          <div className="px-4 py-6 text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-heart-line text-4xl text-gray-500"></i>
            </div>
            <h2 className="text-lg font-semibold mb-2">لا توجد مفضلات</h2>
            <p className="text-gray-400">ابدأ بإضافة المزادات المفضلة لديك</p>
          </div>
        )}
        
        {activeTab === 'profile' && (
          <div className="px-4 py-6">
            <div className="bg-gray-900 rounded-xl p-6 mb-6">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center">
                  <i className="ri-user-line text-2xl text-black"></i>
                </div>
                <div className="mr-4">
                  <h3 className="text-lg font-semibold">أحمد محمد</h3>
                  <p className="text-gray-400">عضو ذهبي</p>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-xl font-bold text-yellow-400">12</div>
                  <div className="text-xs text-gray-400">مزادات فائزة</div>
                </div>
                <div>
                  <div className="text-xl font-bold text-yellow-400">45</div>
                  <div className="text-xs text-gray-400">مشاركات</div>
                </div>
                <div>
                  <div className="text-xl font-bold text-yellow-400">98%</div>
                  <div className="text-xs text-gray-400">معدل النجاح</div>
                </div>
              </div>
            </div>
            
            <div className="space-y-3">
              <div className="bg-gray-900 rounded-xl p-4 flex items-center justify-between">
                <div className="flex items-center">
                  <i className="ri-wallet-line text-yellow-400 ml-3"></i>
                  <span>المحفظة</span>
                </div>
                <i className="ri-arrow-left-s-line text-gray-400"></i>
              </div>
              <div className="bg-gray-900 rounded-xl p-4 flex items-center justify-between">
                <div className="flex items-center">
                  <i className="ri-history-line text-yellow-400 ml-3"></i>
                  <span>تاريخ المزادات</span>
                </div>
                <i className="ri-arrow-left-s-line text-gray-400"></i>
              </div>
              <div className="bg-gray-900 rounded-xl p-4 flex items-center justify-between">
                <div className="flex items-center">
                  <i className="ri-settings-line text-yellow-400 ml-3"></i>
                  <span>الإعدادات</span>
                </div>
                <i className="ri-arrow-left-s-line text-gray-400"></i>
              </div>
            </div>
          </div>
        )}
      </main>
      
      <TabBar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      {/* Copyright at bottom */}
      <div className="fixed bottom-16 left-0 right-0 bg-transparent z-30 pointer-events-none">
        <div className="text-center py-2">
          <p className="text-xs text-gray-500">
            جميع الحقوق محفوظة © 2025 سوم قطر
          </p>
        </div>
      </div>
    </div>
  );
}
